<template>
  <header class="sa-rep-header">
    <div class="sa-rep-header__lead">
      <h1 class="sa-rep-header__title">{{ title }}</h1>
      <p class="sa-rep-header__subtitle">{{ subtitle }}</p>
    </div>
    <div class="sa-rep-header__actions">
      <span v-if="isMock" class="sa-rep-header__mock" role="status">
        <span class="sa-rep-header__mock-dot" aria-hidden="true"></span>
        Dados de demonstração
      </span>
      <button
        type="button"
        class="btnSave sa-rep-header__export"
        :disabled="exportDisabled || exporting"
        @click="$emit('export')"
      >
        {{ exporting ? 'Exportando...' : 'Exportar CSV' }}
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ReportsHeader',
  props: {
    title: { type: String, default: 'Análise e Relatórios' },
    subtitle: {
      type: String,
      default: 'Explore clientes, faturamento, cursos e vendas por empresa',
    },
    isMock: { type: Boolean, default: false },
    exportDisabled: { type: Boolean, default: false },
    exporting: { type: Boolean, default: false },
  },
  emits: ['export'],
};
</script>

<style scoped>
.sa-rep-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  padding: 1.5rem 1.75rem 1.25rem;
  background: linear-gradient(180deg, #fafbff 0%, #ffffff 100%);
  border-bottom: 1px solid var(--dashboard-border, #e8eaf0);
}

.sa-rep-header__title {
  margin: 0 0 0.35rem;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--dashboard-text, #191c24);
  text-align: left;
}

.sa-rep-header__subtitle {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.45;
  color: var(--dashboard-muted, #697386);
  text-align: left;
}

.sa-rep-header__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.sa-rep-header__mock {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  background: #fff8eb;
  color: #8a6d1d;
  font-size: 0.6875rem;
  font-weight: 600;
  border: 1px solid #f0e0b2;
}

.sa-rep-header__mock-dot {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: #d4a017;
}

.sa-rep-header__export {
  min-width: 8.5rem;
}

@media (max-width: 768px) {
  .sa-rep-header {
    padding: 1.25rem;
  }

  .sa-rep-header__title {
    font-size: 1.5rem;
  }

  .sa-rep-header__actions {
    width: 100%;
  }
}
</style>
